import {
	CREATE_SICKBAY_RECORD,
	CREATING_SICKBAY_RECORD,
	GETTING_SICKBAY_RECORD,
	GETTING_SICKBAY_RECORDS,
	GETTING_SICKBAY_STATS,
	GET_SICKBAY_RECORD,
	GET_SICKBAY_RECORDS,
	GET_SICKBAY_STATS,
	SICKBAY_ERROR,
	UPDATE_SICKBAY_RECORD,
	UPDATING_SICKBAY_RECORD
} from '../types'

const initialState = {
	sickBayRecords: [],
	loadingSickBayRecords: false,
	sickBayRecord: null,
	loadingSickBayRecord: false,
	creatingSickBayRecord: false,
	createdSickBayRecord: null,
	updatingSickBayRecord: false,
	updatedSickBayRecord: null,
	sickBayStats: null,
	loadingSickBayStats: false,
	sickBayError: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action) {
	switch (action.type) {
		case GETTING_SICKBAY_RECORDS:
			return {
				...state,
				loadingSickBayRecords: action.payload
			}
		case GET_SICKBAY_RECORDS:
			return {
				...state,
				loadingSickBayRecords: false,
				sickBayError: null,
				sickBayRecords: action.payload
			}
		case GETTING_SICKBAY_RECORD:
			return {
				...state,
				loadingSickBayRecord: action.payload
			}
		case GET_SICKBAY_RECORD:
			return {
				...state,
				loadingSickBayRecord: false,
				sickBayError: null,
				sickBayRecord: action.payload
			}
		case CREATING_SICKBAY_RECORD:
			return {
				...state,
				creatingSickBayRecord: action.payload
			}
		case CREATE_SICKBAY_RECORD:
			return {
				...state,
				creatingSickBayRecord: false,
				sickBayError: null,
				createdSickBayRecord: action.payload
			}
		case UPDATING_SICKBAY_RECORD:
			return {
				...state,
				updatingSickBayRecord: action.payload
			}
		case UPDATE_SICKBAY_RECORD:
			return {
				...state,
				updatingSickBayRecord: false,
				sickBayError: null,
				updatedSickBayRecord: action.payload
			}
		case GETTING_SICKBAY_STATS:
			return {
				...state,
				loadingSickBayStats: action.payload
			}
		case GET_SICKBAY_STATS:
			return {
				...state,
				loadingSickBayStats: false,
				sickBayError: null,
				sickBayStats: action.payload
			}
		case SICKBAY_ERROR:
			return {
				...state,
				loadingSickBayRecords: false,
				loadingSickBayRecord: false,
				creatingSickBayRecord: false,
				updatingSickBayRecord: false,
				loadingSickBayStats: false,
				sickBayError: action.error
			}
		default:
			return state
	}
}

